import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';
import { NotificationContext } from '../../../NotificationContext';

const defaultSx = {
    root: {
        background: (theme) => theme.palette.primary.default,
        color: (theme) => theme.palette.primary.contrastText,
    },
};

const TitledPage = ({ title, subtitle, children, sx }) => {
    const { setToolbarContent } = useContext(NotificationContext);
    useEffect(() => {
        setToolbarContent({ title, subtitle });
        return () => setToolbarContent({ title: '', subtitle: null, content: null });
    }, []);

    return (
        <Box sx={{ ...defaultSx, ...sx }}>
            <Helmet>
                <title>{`${title} - Milk Moovement`}</title>
            </Helmet>
            {children}
        </Box>
    );
};

export default TitledPage;
